module.exports = __webpack_public_path__ + "static/media/down-arrow.ce357919.svg";